import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import {
  AdminServerTableCellContext,
  AdminServerTableColumn,
  AdminServerTablePaginationState,
} from '../../../shared/table/models/admin-server-table.model';
import { CementoParametrosStore } from '../../../stores/parametros-cemento.store';
import { buildParametrosCementoColumns } from './parametros-cemento-tabla.component.columns';
import { CementoParametroDto } from '../../../models/parametro-cemento.dto';
import { ParametroCementoEditModalComponent } from '../components/parametro-cemento-edit-modal/parametro-cemento-edit-modal.component';
import { ToastService } from 'src/app/services/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-parametros-cemento-tabla',
  templateUrl: './parametros-cemento-tabla.component.html',
  styleUrls: ['./parametros-cemento-tabla.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParametrosCementoTablaComponent implements OnInit {
  @ViewChild('actionsCellTpl', { static: true })
  actionsCellTpl!: TemplateRef<AdminServerTableCellContext<CementoParametroDto>>;

  protected readonly store = inject(CementoParametrosStore);
  private readonly modalService = inject(NgbModal);
  private readonly toastService = inject(ToastService);
  private readonly spinner = inject(NgxSpinnerService);

  readonly tableColumns: AdminServerTableColumn<CementoParametroDto>[] = [];

  ngOnInit(): void {
    this.tableColumns.push(
      ...buildParametrosCementoColumns({
        actionsCellTemplate: this.actionsCellTpl,
      }),
    );
    this.store.loadItems();
  }

  get paginationState(): AdminServerTablePaginationState {
    const q = this.store.query();
    const total = this.store.total();
    const totalPages = Math.max(1, Math.ceil(total / q.pageSize));
    return {
      page: q.page,
      pageSize: q.pageSize,
      total,
      totalPages,
      hasPreviousPage: q.page > 1,
      hasNextPage: q.page < totalPages,
      pageStartIndex: total === 0 ? 0 : (q.page - 1) * q.pageSize + 1,
      pageEndIndex: Math.min(total, q.page * q.pageSize),
      pageSizeOptions: [10, 20, 50, 100],
    };
  }

  readonly trackByItem = (_: number, item: CementoParametroDto): number => item.id;

  onSearchTermChange(value: string | number): void {
    this.store.setSearchTerm(String(value ?? ''));
  }

  onOrderingChange(value: string): void {
    this.store.setOrdering(value);
  }

  onPageChange(value: number): void {
    this.store.setPage(value);
  }

  onPageSizeChange(value: number): void {
    this.store.setPageSize(value);
  }

  openEditModal(param: CementoParametroDto): void {
    const modalRef = this.modalService.open(ParametroCementoEditModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.param = param;

    modalRef.result
      .then((updatedData: unknown) => {
        if (updatedData) {
          this.spinner.show();
          this.store.updateItem(param.id, updatedData as Partial<CementoParametroDto>).subscribe({
            next: () => {
              this.toastService.showAdminSuccess('Parámetro actualizado correctamente');
              this.spinner.hide();
            },
            error: () => {
              this.toastService.showAdminError('Error al actualizar el parámetro');
              this.spinner.hide();
            },
          });
        }
      })
      .catch(() => {});
  }
}
